// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.guide-enterprise-sso h2[data-v-48236f9f]{scroll-margin-top:80px}.guide-enterprise-sso h3[data-v-48236f9f]{margin-top:1.5rem}.guide-enterprise-sso code[data-v-48236f9f]{background:#f1f5f9;padding:1px 6px;border-radius:3px;font-size:.92em}`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
